import { useMutateEntry, makeInitialOpgavekompleksetTaskEntry } from '@utils/component-framework';
import { useOpgavekompleksetComponent } from '../context.data.js';
import { updateStats } from './util.update-stats.js';

function useSkipCurrentTaskMutation() {
  const {
    entryKey,
    data
  } = useOpgavekompleksetComponent();
  const mutater = useMutateEntry(entryKey);
  return () => mutater(entry => {
    const activeTaskId = entry.data.activeTaskId ?? data.tasks[0]?.id;
    if (!activeTaskId) {
      return entry;
    }
    const task = entry.data.tasks[activeTaskId] ??= makeInitialOpgavekompleksetTaskEntry(data, activeTaskId);
    task.state.skipped = true;
    task.state.closed = true;
    updateStats(entry, data, activeTaskId);
    const activeTaskIndex = data.tasks.findIndex(it => it.id === activeTaskId);
    const nextTaskIndex = activeTaskIndex + 1;
    const nextTask = data.tasks[nextTaskIndex];
    entry.data.activeTaskId = nextTask?.id ?? null;
    return entry;
  });
}

export { useSkipCurrentTaskMutation };
//# sourceMappingURL=task.skip.js.map
